var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSurveys(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.6,76.4l-18-18c-1-1-1-2.6,0-3.5c1-1,2.6-1,3.5,0l14.5,14.5l28.2-28.2c1-1,2.6-1,3.5,0c1,1,1,2.6,0,3.5 L57.6,76.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82,136.7H47v-34.9H82V136.7z M52,131.7h25v-25H52V131.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82,198H47v-35H82V198z M52,193h25v-25H52V193z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 110.4,
    y: 54.9,
    className: "st0",
    width: 99.9,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.4,
    y: 116.2,
    className: "st0",
    width: 99.9,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.4,
    y: 177.5,
    className: "st0",
    width: 99.9,
    height: 5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSurveys);
export default __webpack_public_path__ + "static/media/ic-surveys.e02674bf21c327387e9f03dc29134378.svg";
export { ForwardRef as ReactComponent };